import { render, staticRenderFns } from "./AthleteRecruitingProfileView.vue?vue&type=template&id=4922f876&scoped=true&"
import script from "./AthleteRecruitingProfileView.vue?vue&type=script&lang=ts&"
export * from "./AthleteRecruitingProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteRecruitingProfileView.vue?vue&type=style&index=0&id=4922f876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922f876",
  null
  
)

export default component.exports